import { render, staticRenderFns } from "./auth-add.vue?vue&type=template&id=66f11093&scoped=true&"
import script from "./auth-add.vue?vue&type=script&lang=js&"
export * from "./auth-add.vue?vue&type=script&lang=js&"
import style0 from "./auth-add.vue?vue&type=style&index=0&id=66f11093&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f11093",
  null
  
)

export default component.exports